import React from 'react';
import s from './box.module.css';
export default function ProjectTabBox({variant:p}) {
 if(!p) return null;
 return <article className={`${s.container} ${!p.img ? s.textOnly : ''}`} id={p.id}>{p.img && <div className={`${s.picture} ${p.imageTheme === 'dark' ? s.darkImage : ''}`}><img src={p.img} alt={p.alt || p.title} loading="lazy"/></div>}<div className={s.text}>
 <p className={s.meta}>{p.category}{p.period ? ` · ${p.period}` : ''}{p.status ? ` · ${p.status}` : ''}</p><h2>{p.title}</h2>
 <p className={s.body}>{p.body.trim()}</p>
 {p.role && <p className={s.body}><strong>담당 역할</strong><br/>{p.role}</p>}
 {p.stack && <p className={s.body}><strong>사용 기술</strong><br/>{p.stack.trim()}</p>}
 {p.strong && <p className={s.body}>{p.strong}</p>}{p.activity && <p className={s.body}>{p.activity.trim()}</p>}
 {p.links && <div className={s.serviceLinks}>{p.links.map(link => <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer">{link.label} ↗</a>)}</div>}
 <ul className={s.tags}>{(p.hashtag || []).map(tag=><li key={tag}>{tag}</li>)}</ul></div></article>;
}
